// src/router/routes.ts
import type { Locale } from './locales'
import type { RouteKey } from './routeDefs'

export const routeTranslations: Record<RouteKey, Record<Locale, string>> = {
  home: { no: '', en: '' },
  notFound: { no: '404', en: '404' },
  preview: { no: 'preview', en: 'preview' },
  page: { no: ':slug', en: ':slug' },
  gym: { no: 'treningssenter/:slug', en: 'gyms/:slug' },
  trainer: { no: 'personlig-trener/:slug', en: 'personal-trainer/:slug' },
  campaign: { no: 'kampanje/:slug', en: 'campaign/:slug' },
  post: { no: ':category/:slug', en: ':category/:slug' },
}

export type RouteName = keyof typeof routeTranslations
